export const MAX_NAME_LENGTH = 8
